import { render, staticRenderFns } from "./UserDocument.vue?vue&type=template&id=bd8e1c62&"
import script from "./UserDocument.vue?vue&type=script&lang=js&"
export * from "./UserDocument.vue?vue&type=script&lang=js&"
import style0 from "./UserDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports